export const STATUS_MAPPING = {
	INACTIVE: 'Disable',
	ACTIVE: 'Enable',
};
